var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 1.89453C4.25 1.48032 4.58579 1.14453 5 1.14453H19C19.4142 1.14453 19.75 1.48032 19.75 1.89453V8.89453C19.75 12.9217 16.6783 16.2315 12.75 16.6087V21.375H17C17.4142 21.375 17.75 21.7108 17.75 22.125C17.75 22.5392 17.4142 22.875 17 22.875H7C6.58579 22.875 6.25 22.5392 6.25 22.125C6.25 21.7108 6.58579 21.375 7 21.375H11.25L11.25 16.6087C7.3217 16.2315 4.25 12.9217 4.25 8.89453V1.89453ZM5.75 2.64453H18.25V5.55988C18.2412 5.6058 18.2366 5.63368 18.2366 5.68216C18.2366 7.58946 16.9713 8.81888 15.2847 9.43887C14.4434 9.74811 13.5328 9.88675 12.7084 9.86766C11.8716 9.84828 11.1911 9.66861 10.768 9.40823C9.07067 8.3637 7.13152 8.33022 5.75 8.63947V2.64453ZM15.8022 10.8468C14.7781 11.2232 13.6796 11.3906 12.6736 11.3673C11.6801 11.3442 10.709 11.1332 9.98189 10.6857C8.58406 9.82552 6.92912 9.86464 5.8766 10.1523C6.45869 13.0012 8.97905 15.1445 12 15.1445C15.2948 15.1445 17.9942 12.595 18.2328 9.36111C17.5459 10.0437 16.6885 10.521 15.8022 10.8468Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/glass.85736519d83d83eee85dcc8288a68f6a.svg";
export { ForwardRef as ReactComponent };